import { createContext } from 'react';

const GalleryContext = createContext<{
    shareIdentifier: string | null;
    setShareIdentifier: (shareIdentifier: string | null) => void;
    baseUrl: string | null;
    slug: string | null;
}>({
    shareIdentifier: null,
    setShareIdentifier: () => {},
    baseUrl: null,
    slug: null,
});

export default GalleryContext;
